export default __webpack_public_path__ + "static/media/1111.a5aee0a0.png";